var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolioProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#667eea",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#764ba2",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 500,
    height: 300,
    rx: 8,
    fill: "#ffffff",
    stroke: "#e1e5e9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 500,
    height: 40,
    rx: 8,
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 6,
    fill: "#ff5f56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 20,
    r: 6,
    fill: "#ffbd2e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 20,
    r: 6,
    fill: "#27ca3f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 12,
    width: 350,
    height: 16,
    rx: 8,
    fill: "#ffffff",
    stroke: "#e1e5e9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 460,
    height: 220,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 420,
    height: 60,
    rx: 4,
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 115,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#343a40"
  }, "Portfolio Website"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 160,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#6c757d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 160,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#6c757d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 160,
    width: 70,
    height: 8,
    rx: 4,
    fill: "#6c757d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 160,
    width: 50,
    height: 8,
    rx: 4,
    fill: "#6c757d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 190,
    width: 200,
    height: 60,
    rx: 4,
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 190,
    width: 200,
    height: 60,
    rx: 4,
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 30,
    rx: 4,
    fill: "#28a745",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 20,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 12,
    fill: "white"
  }, "&lt;/&gt;")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioProject);
export default __webpack_public_path__ + "static/media/portfolio-project.fc507c8a8929560828b4e370ed345944.svg";
export { ForwardRef as ReactComponent };